export const version = {Version: "1.0.8", dateBuild: "06/06/2026"}